import { TokenStorage } from 'src/app/token.storage';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// import {
//   APP_ID,
//   API_URL_NZ,
//   API_URL_IN,
//   API_URL_PROMOTION,
//   API_URL_IO,
// } from '../app.component';
import { Room } from '../model/room';
import { Booking } from '../model/booking';
import { Msg } from '../model/msg';
import { Payment } from '../model/payment';
import { MessageDto } from '../model/MessageDto';
import { Customer } from '../model/customer';
import { PropertyServiceDTO } from '../model/PropertyServices';
// import { EnquiryDto } from '../model/enquiry';
import { environment } from 'src/environments/environment';
import { API_URL_IN, API_URL_NZ, APP_ID } from '../app.component';
// import { WhatsappDto } from '../model/whatsappDto';
// import { externalReservationDtoList } from '../model/externalReservation';


@Injectable({
  providedIn: 'root',
})
export class HotelBookingService {
  API_URL: string;
  constructor(private http: HttpClient, private token: TokenStorage) {
    this.setApi();
    // this.API ="https://testapi.bookonelocal.co.nz/bookone-scheduler"
  }


  setApi() {
   
      this.API_URL = API_URL_IN;
  
  }
  authorisationToken(message: MessageDto) {
    this.setApi();
    let headers = new HttpHeaders({
      'APP_ID': APP_ID,
    });
    return this.http.post<MessageDto[]>(
      this.API_URL + '/api/message/authorisationToken',
      message,
      { headers: headers }
    );
  }


  getBookingDetailsbyres(bookingNumber: number, bookingEmail: string) {
    this.setApi();
    return this.http.get<any>(
      environment.apiUrlBookone +
      '/api/website/findBookingByIdAndEmail?BookingReferenceNumber=' +
      bookingNumber +
      '&BookingEmail=' +
      bookingEmail,
      { observe: 'response' }
    );
  }
  send(message: MessageDto) {
    this.setApi();
    return this.http.post<MessageDto[]>(
      this.API_URL + '/api/message/send',
      message,
      { observe: 'response' }
    );
  }
  verifyAuthorisationToken(message: MessageDto) {
    this.setApi();
    let headers = new HttpHeaders({
      'APP_ID': APP_ID,
    });
    return this.http.post<MessageDto[]>(
      this.API_URL + '/api/message/verifyAuthorisationToken',
      message,
      { headers: headers }
    );
  }


  getAllServicesByBooking(bookingId: number) {
    return this.http.get<PropertyServiceDTO[]>(
      this.API_URL + "/api/booking/findAllServices/" + bookingId,
      { observe: "response" }
    );
  }


  addServicesToBooking(services: PropertyServiceDTO[], bookingId: number) {
    this.setApi();
    return this.http.post<PropertyServiceDTO[]>(
      this.API_URL + '/api/thm/add/services/' + bookingId,
      services,
      { observe: 'response' }
    );
  }
  addServicesToBookingObe(services: PropertyServiceDTO[], bookingId: number) {
    this.setApi();
    return this.http.post<PropertyServiceDTO[]>(
  'https://api.bookone.io' + '/api/website/add/services/' + bookingId,
      services,
      { observe: 'response' }
    );
  }
  findAllSuburbByCities(city: string) {
    return this.http.get<any[]>(this.API_URL + '/api/thm/allSuburbByCities?city=' + city, { observe: 'response' });
  }
  getCustomerDetailsByEmail(email: string) {
    this.setApi();
    return this.http.get<Customer>(
      this.API_URL + '/api/thm/email/' + email + '/',
      { observe: 'response' }
    );
  }
  getCustomerDetailsByMobile(mobile: string) {
    this.setApi();
    return this.http.get<Customer>(
      this.API_URL + '/api/thm/mobile/' + mobile,
      { observe: 'response' }
    );
  }
  getBookingConfirmation(bookingId: string) {
    this.setApi();
    return this.http.get<Booking>(
      this.API_URL + '/api/thm/confirm?BookingId=' + bookingId,
      { observe: 'response' }
    );
  }
  getRoomDetailsByPropertyId(propertyId: number) {
    this.setApi();
    return this.http.get<Room[]>(
      this.API_URL + '/api/thm/findAllRoomsByPropertyId/' + propertyId,
      { observe: 'response' }
    );
  }
  createBooking(booking: Booking) {
    this.setApi();
    return this.http.post<Booking>(
      "https://api.thehotelmate.co" + '/api/thm/booking',
      booking,
      { observe: 'response' }
    );
  }
  createBookingObe(booking: Booking) {
    this.setApi();
    return this.http.post<Booking>(
      "https://api.bookone.io" + '/api/website/booking',
      booking,
      { observe: 'response' }
    );
  }
  // externalReservation(externalReservation: externalReservationDtoList[]) {
  //   this.setApi();
  //   return this.http.post<any[]>(
  //     'https://api.bookone.io/channel-integration'+ '/api/external/reservation/',
  //     externalReservation,
  //     { observe: 'response' }
  //   );
  // }
  checkAvailability(booking: any) {
    return this.http.post<any>(
      this.API_URL + '/api/thm/checkAvailability',
      booking,
      { observe: 'response' }
    );
  }
  checkAvailabilityByProperty(
    fromDate,
    toDate,
    noOfRooms,
    noOfPersons,
    propertyId
  ) {
    this.setApi();
    return this.http.get<any>(
     'https://api.thehotelmate.co' +
      '/api/thm/checkAvailability/' +
      propertyId +
      '?fromDate=' +
      fromDate +
      '&toDate=' +
      toDate +
      '&noOfRooms=' +
      noOfRooms +
      '&noOfPersons=' +
      noOfPersons,
      { observe: 'response' }
    );
  }
  getRoomDetailsByPropertyIdAndDate(
    propertyId: number,
    fromDate: string,
    toDate: string
  ) {
    this.setApi();
    return this.http.get<any[]>(
      this.API_URL +
      '/api/thm/getAllRoomsByDate?PropertyId=' +
      propertyId +
      '&FromDate=' +
      fromDate +
      '&ToDate=' +
      toDate,
      { observe: 'response' }
    );
  }
  sendTextMessage(message: Msg) {
    this.setApi();
    return this.http.post<Msg>(
      environment.apiUrlBookone + '/api/website/message/send',
      message,
      { observe: 'response' }
    );
  }
  getBookingDetails(bookingNumber: number, bookingEmail: string) {
    this.setApi();
    return this.http.get<any>(
      this.API_URL +
      '/api/thm/findBookingByIdAndEmail?BookingReferenceNumber=' +
      bookingNumber +
      '&BookingEmail=' +
      bookingEmail,
      { observe: 'response' }
    );
  }
  getBookingDetailsOBE(bookingNumber: number, bookingEmail: string) {
    this.setApi();
    return this.http.get<any>(
      environment.apiUrlBookone +
      '/api/website/findBookingByIdAndEmail?BookingReferenceNumber=' +
      bookingNumber +
      '&BookingEmail=' +
      bookingEmail,
      { observe: 'response' }
    );
  }
  getBookingDetailsone(RefferenceNumber: string) {
    this.setApi();
    return this.http.get<any>(
      this.API_URL +
      '/api/thm/findBookingByIdAndEmail?BookingReferenceNumber=' +
      RefferenceNumber,
      { observe: 'response' }
    );
  }
  getBookingDetailsById(bookingNumber: number) {
    this.setApi();
    return this.http.get<any>(
      environment.apiUrlBookone +
      '/api/website/findBookingById?BookingId=' +
      bookingNumber ,
      { observe: 'response' }
    );
  }
  getPlan(propertyId: string, roomId: string) {
    this.setApi();
    return this.http.get<any[]>(
      this.API_URL +
      '/api/thm/property/' +
      propertyId +
      '/room/' +
      roomId +
      '/roomPlan',
      { observe: 'response' }
    );
  }
  getPaymentById(bookingNumber: number) {
    this.setApi();
    return this.http.get<any>(
      environment.apiUrlBookone +
      "/api/website/findPaymentByReferenceNumber/" + bookingNumber ,
          { observe: 'response' }
    );
  }
  paymentIntent(paymentDetails: Payment) {
    return this.http.post<Payment>(
      "https://api.thehotelmate.co" + '/api/thm/paymentIntent',
      paymentDetails,
      { observe: 'response' }
    );
  }
  // paymentIntentHdfc(paymentDetails: Payment) {
  //   return this.http.post<Payment>(
  //     API_URL_IO  + '/hdfc/api/hdfc/paymentIntent',
  //     paymentDetails,
  //     { observe: 'response' }
  //   );
  // }
  paymentIntentPhonepe(paymentDetails: Payment) {
    return this.http.post<Payment>(
      'https://phonepe.bookonepms.com/api/phonepe/paymentIntent',
      paymentDetails,
      { observe: 'response' }
    );
  }
  paymentIntentRayzorpay(paymentDetails: Payment) {
    return this.http.post<Payment>(
      'https://razorpay.payment.uat.bookone.io/api/razorpay/paymentIntent',
      paymentDetails,
      { observe: 'response' }
    );
  }
  processPayment(paymentDetails: Payment) {
    this.setApi();
    return this.http.post<Payment>(
     "https://api.thehotelmate.co" + '/api/thm/processPayment',
      paymentDetails,
      { observe: 'response' }
    );
  }
  processPaymentObe(paymentDetails: Payment) {
    this.setApi();
    return this.http.post<Payment>(
     "https://api.bookone.io" + '/api/website/processPayment',
      paymentDetails,
      { observe: 'response' }
    );
  }
  savePayment(paymentDetails: Payment) {
    this.setApi();
    return this.http.post<Payment>(
      this.API_URL + '/api/thm/savePayment',
      paymentDetails,
      { observe: 'response' }
    );
  }
  savePaymentObe(paymentDetails: Payment) {
    this.setApi();
    return this.http.post<Payment>(
    'https://api.thehotelmate.co' + '/api/website/savePayment',
      paymentDetails,
      { observe: 'response' }
    );
  }
  getPaymentByReffId(ref: string) {
    this.setApi();
    return this.http.get<Payment[]>(
      "https://api.thehotelmate.co" +
      '/api/thm/findPaymentByReferenceNumber/' + ref,
      { observe: 'response' }
    );
  }
  getPaymentByReffIdObe(ref: string) {
    this.setApi();
    return this.http.get<Payment[]>(
      "https://api.bookone.io" +
      '/api/website/findPaymentByReferenceNumber/' + ref,
      { observe: 'response' }
    );
  }
  // getOfferDetailsBySeoFriendlyName(seoName: string) {
  //   this.setApi();
  //   return this.http.get<any>(
  //     API_URL_PROMOTION + '/api/offer/findBySeofriendlyName/' + seoName + '/',
  //     { observe: 'response' }
  //   );
  // }


  // accommodationEnquiry(enquiry: EnquiryDto) {
  //   this.setApi();
  //   return this.http.post<EnquiryDto>(
  //     environment.apiLms + '/api/v1/accommodationEnquiry',
  //     enquiry,
  //     { observe: 'response' }
  //   );
  // }


  // emailEnquire(enquiry: EnquiryDto) {
  //   this.setApi();
  //   return this.http.post<EnquiryDto>(
  //     environment.apiUrlBookone + '/api/email/enquire',
  //     enquiry,
  //     { observe: 'response' }
  //   );
  // }
  // whatsAppMsg(whatsappmsg: WhatsappDto) {
  //   this.setApi();
  //   return this.http.post<WhatsappDto>(
  //     environment.apiScheduler + '/api/whatsapp/sendMessage',
  //     whatsappmsg,
  //     { observe: 'response' }
  //   );
  // }
  saveBookingService(bookingId: number,planPropertyServicesList: PropertyServiceDTO[] ) {
    return this.http.post<Booking>(environment.inAPIUrl + "/api/booking/add/services/"+bookingId, planPropertyServicesList, {
      observe: "response",
    });
  }


}



